import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Tracern ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <AppErrorScreen error={this.state.error} onRetry={() => window.location.reload()} />;
    }
    return this.props.children;
  }
}

export function AppErrorScreen({ error, onRetry }) {
  const isNetworkError = error?.message?.includes('Network') ||
                         error?.message?.includes('fetch') ||
                         error?.code === 'ERR_NETWORK';

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.iconWrap}>
          <span style={{ fontSize: '40px' }}>{isNetworkError ? '📡' : '⚙️'}</span>
        </div>

        <h1 style={S.title}>
          {isNetworkError ? 'Tracern is unreachable' : 'Something went wrong'}
        </h1>

        <p style={S.message}>
          {isNetworkError
            ? 'We cannot reach the Tracern server right now. ' +
              'Please check your internet connection or try again in a moment.'
            : 'An unexpected error occurred. ' +
              'This has been noted. Please reload the page.'}
        </p>

        {process.env.NODE_ENV === 'development' && error?.message && (
          <div style={S.debugBox}>
            <p style={{ fontFamily: 'monospace', fontSize: '12px', color: '#ef4444', wordBreak: 'break-all' }}>
              {error.message}
            </p>
          </div>
        )}

        <div style={S.actions}>
          <button onClick={onRetry || (() => window.location.reload())} style={S.retryBtn}>
            Reload Page
          </button>
          <a href="/login" style={S.loginLink}>Go to Login</a>
        </div>

        <p style={S.footer}>
          If the problem persists, contact{' '}
          <strong style={{ color: 'var(--color-primary)' }}>Tracern Support</strong>
        </p>
      </div>
    </div>
  );
}

const S = {
  page: {
    minHeight: '100vh', display: 'flex', alignItems: 'center',
    justifyContent: 'center', background: 'var(--color-bg)', padding: '24px',
  },
  card: {
    background: 'var(--color-surface)', borderRadius: '20px',
    padding: '40px 32px', width: '100%', maxWidth: '440px',
    textAlign: 'center', border: '1px solid var(--color-border)',
    boxShadow: 'var(--shadow-lg)',
  },
  iconWrap: {
    width: '72px', height: '72px', borderRadius: '20px',
    background: 'var(--color-bg)', display: 'flex', alignItems: 'center',
    justifyContent: 'center', margin: '0 auto 20px',
    border: '1px solid var(--color-border)',
  },
  title:    { fontSize: '20px', fontWeight: 700, color: 'var(--color-text)', marginBottom: '12px' },
  message:  { fontSize: '14px', color: 'var(--color-text-secondary)', lineHeight: 1.7, marginBottom: '24px' },
  debugBox: {
    background: '#FFF5F5', border: '1px solid #FEB2B2',
    borderRadius: 'var(--radius-sm)', padding: '10px 12px', marginBottom: '20px', textAlign: 'left',
  },
  actions:  { display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' },
  retryBtn: {
    padding: '11px', borderRadius: 'var(--radius-md)',
    background: 'var(--color-primary)', color: '#fff',
    border: 'none', cursor: 'pointer', fontSize: '14px', fontWeight: 600,
  },
  loginLink:{
    display: 'block', padding: '11px', borderRadius: 'var(--radius-md)',
    background: 'var(--color-bg)', color: 'var(--color-text-secondary)',
    border: '1px solid var(--color-border)',
    textDecoration: 'none', fontSize: '14px',
  },
  footer:   { fontSize: '13px', color: 'var(--color-text-muted)' },
};
